import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core'; // Assuming @ngx-translate/core is still used
import { PermissionService } from '~/app/core/auth/services/permission.service'; // Adjust path
import { MessageService, TOASTTYPE } from '~/app/core/services/message.service'; // Adjust path

/**
 * Description: Checks if user has the right scopes to access the wanted module or its children.
 * This guard can be used for both `canActivate` and `canActivateChild`.
 */
const checkScopeAccess = (route: ActivatedRouteSnapshot): boolean => {
  const router = inject(Router);
  const messageService = inject(MessageService);
  const permissionService = inject(PermissionService);
  const translate = inject(TranslateService);

  if (route.data && route.data['scopes']) {
    if (!permissionService.checkScopes(route.data['scopes'])) {
      router.navigate(['/']);
      setTimeout(() => {
        messageService.showToast(TOASTTYPE.ERROR, translate.instant('general.missingScopes'));
      }, 500);
      return false;
    }
  }
  return true;
};

export const scopeCanActivateGuard: CanActivateFn = (route, state) => {
  return checkScopeAccess(route);
};

export const scopeCanActivateChildGuard: CanActivateChildFn = (childRoute, state) => {
  return checkScopeAccess(childRoute);
};
